import React, { ReactNode } from 'react';
import { withRouter } from 'react-router';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { PayPayRedirectComponentView } from './PayPayRedirectComponentView';
import { paypayHtmlContents, paypayHtmlMetaData, paypayScripts, paypayBodyAttribure } from '../select-payment/SelectPaymentComponentView';


/**
 * メール送信完了コンポーネント
 */
class PayPayRedirectComponent extends WprBaseRouteViewComponent {
	private scriptIdList: string[] = [];

	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new PayPayRedirectComponentView(), props);
		// document.getElementsByTagName('meta')[0].getAttributeNode('charset').nodeValue = 'Shift_JIS';	
		if (paypayHtmlMetaData !== undefined && paypayHtmlMetaData !== null) {
			for (let meta of paypayHtmlMetaData) {
				document.getElementsByTagName('head')[0].appendChild(meta);
			}
			if (document.getElementsByTagName('meta')[0].hasAttribute('charset')) {
				document.getElementsByTagName('meta')[0].removeAttribute('charset');
				document.getElementsByTagName('meta')[0].setAttribute('http-equiv', 'Content-Type');
				document.getElementsByTagName('meta')[0].setAttribute('content', 'text/html; charset=Shift_JIS');
			}
		}
		if (paypayScripts !== undefined && paypayScripts !== null) {
			for (let scripts of paypayScripts) {
				if (scripts.innerHTML.includes('function OnLoadEvent'))
					scripts.setAttribute('id', 'loadevent');
				document.documentElement.insertBefore(scripts, document.body);
			}
		}
		if (paypayBodyAttribure !== undefined && paypayBodyAttribure !== null) {
			for (let bodyAttr of paypayBodyAttribure) {
				if (!document.body.getAttribute(bodyAttr.name))
					document.body.setAttribute(bodyAttr.name, bodyAttr.value);
			}
		}
	}
	// --------------------------------------------------------------------------

	componentDidMount() {
		// onloadの実行
		if (process.env.PAYPAY_PRODUCTION_MODE === 'true') {
			const script = document.createElement('script');
			const onLoadElement = document.getElementById('loadevent');
			let functionText = onLoadElement.innerHTML;
			const firstFuncIdx = functionText.indexOf('{');
			functionText = functionText.substr(firstFuncIdx + 1);
			const lastFuncIdx = functionText.indexOf('}');
			functionText = functionText.substr(0, lastFuncIdx);
			functionText = functionText.replaceAll('\r\n', '');
			script.innerHTML = functionText;
			document.body.appendChild(script);
		}
	}

	// override メソッド  --------------------------------------------------------
	/**
     * 描画
     */
	public onRender(): ReactNode {
		if (paypayHtmlContents.getElementsByTagName('form')[0] !== undefined
				&& paypayHtmlContents.getElementsByTagName('form')[0] !== null) {
			if (!paypayHtmlContents.getElementsByTagName('form')[0].hasAttribute('accept-charset')) {
				paypayHtmlContents.getElementsByTagName('form')[0].setAttribute('accept-charset', 'Shift_JIS');
			}
		}
		return (
			<div dangerouslySetInnerHTML={createPayPayMarkup()} />
		);
	}
	// --------------------------------------------------------------------------
}

function createPayPayMarkup() {
	return {__html: paypayHtmlContents.outerHTML};
}

export default withRouter(PayPayRedirectComponent);